import { reduce, uniq } from "lodash";

import { keyArrayFromMap } from "../../../../utils/immutableExtensions";
import batchUtils from "../../../batchUtils";

export const getAffectedActionIds = (state, action, globalActionTypes, individualActionTypes, includeIdProp = true) => {
  const globalAction = batchUtils.findActionOfTypes(action, globalActionTypes);
  let affectedIds = [];
  let matchedGlobal = false;
  let matchedIndividual = false;
  if (globalAction) {
    affectedIds = keyArrayFromMap(state);
    matchedGlobal = true;
  }
  const individualActions = batchUtils.findActionsOfTypes(action, individualActionTypes);
  if (individualActions.length) {
    affectedIds = getIdsFromActions(individualActions, includeIdProp);
    matchedIndividual = true;
  }
  return {
    affectedIds,
    matchedGlobal,
    matchedIndividual
  };
};

export const getIdsFromActions = (actions, includeIdProp = true) =>
  uniq(
    reduce(
      actions,
      (result, a) => {
        if (a.ids) {
          result.push(...a.ids);
        } else if (includeIdProp && a.id) {
          result.push(a.id);
        }
        return result;
      },
      []
    )
  );
